<template>
    <div>
        <el-header class="header" height="80px">
            <Header class="animate__animated animate__fadeInDown" :websiteData="websiteData" :menuShow="true"/>
        </el-header>

        <div style="overflow-x: hidden;">
            <div class="bannerheight bannerbg"
                 style="background-image: url('http://free.demo.demososo.com/DM-static/upload/image/common/20190718_180006_8297.jpg');">
                <div class="dmbanneroverlay"></div>
                <div class="title-text animate__animated animate__fadeInUp">
                    <p style="color: #fff;font-size: 40px;font-weight: 500;">
                        {{contentData.title}}
                    </p>
                </div>
            </div>
            <div class="margin">
                <div style="display: flex;justify-content: space-between;padding: 0 20px;align-items: center">
                    <div style="font-weight: bold">
                        {{contentData.title}}
                    </div>
                    <div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>{{contentData.classifyTitle}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{contentData.title}}详情</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>

                <el-divider></el-divider>

                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div style="display: flex;justify-content: center;align-items: center;">
                            <el-image
                                   v-if="contentData.url"
                                    style="width: 90%;"
                                    lazy
                                    :preview-src-list="[contentData.url]"
                                    :src='contentData.url'>
                                <div slot="error" class="image-slot"
                                     style="display: flex;justify-content: center;align-items: center;height: 100%;">
                                    <i style="font-size: 40px" class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                    </el-col>
                    <el-col id="content" class="col" :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div style="padding: 0 20px;">
                            <el-tabs v-model="activeName" type="card">
                                <el-tab-pane label="内容详情" name="1">
                                    <div style="font-size: 20px;font-weight: bold;margin: 10px 0;">
                                        {{contentData.subtitle}}
                                    </div>
                                    <div v-html="contentData.content" class="ql-editor" style="color: #333;font-size: 14px;padding: 0;"/>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </el-col>
                </el-row>

                <div style="font-weight: bold;margin: 20px 0 0 0;padding: 0 20px;">
                    相关产品
                </div>

                <el-divider></el-divider>

                <el-row :gutter="20">
                    <el-carousel class="hidden-sm-and-down" :interval="4000" height="250px">
                        <el-carousel-item v-for="(item,index) in arrCardContent" :key="index">
                            <el-col v-for="(item2,index2) in item" :key="index2"
                                    :xs="24" :sm="6"
                                    :md="6" :lg="6" :xl="6">
                                <div @click="productClick(item2)"
                                     style="display: flex;flex-direction: column;align-items: center">
                                    <img style="cursor: pointer" width="220" height="220"
                                         :src="item2.url"/>
                                    <div style="margin-top: 10px;text-align: center;width: 220px;font-size: 14px;white-space: nowrap;overflow-x: hidden;text-overflow: ellipsis;color: #0094ff;font-weight: bold;cursor: pointer">
                                        {{item2.title}}
                                    </div>
                                </div>
                            </el-col>
                        </el-carousel-item>
                    </el-carousel>
                </el-row>

                <el-carousel class="hidden-sm-and-up" style="padding: 0 20px;" :interval="4000" height="250px">
                    <el-carousel-item v-for="(item,index) in listCardContent" :key="index">
                        <div @click="productClick(item)">
                            <img width="100%" height="200"
                                 :src="item.url"/>
                            <div style="margin-top: 10px;width: 100%;white-space: nowrap;overflow-x: hidden;text-overflow: ellipsis;text-align: center;font-size: 18px;font-weight: bold;color: #0094ff">
                                {{item.title}}
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <el-footer style="background: #0094ff;height: 100%;padding: 20px 0;overflow-x: hidden">
            <Footer :websiteData="websiteData"/>
        </el-footer>
    </div>

</template>

<script>
    import Header from "@/components/header/index"
    import Footer from "@/components/footer/index"
    import {getContentInfo, listCardContent} from "@/api/content"
    import _ from "lodash"

    export default {
        name: "productDetails",
        components:{
            Header,
            Footer
        },
        data() {
            return {
                activeName: '1',
                contentData: {},
                listCardContent: [],
                arrCardContent: [],
                websiteData:{},
            }
        },
        created() {
            this.getWebsiteData()
            this.getInfo()

            listCardContent().then(response => {
                this.listCardContent = response.data
                this.arrCardContent = _.chunk(response.data, 4)
            })

        },
        methods: {
            getWebsiteData(){
                let data = sessionStorage.getItem('websiteData')
                if (data) {
                    this.websiteData = JSON.parse(data)
                }
            },
            // 点击产品
            productClick(data) {
                getContentInfo(data.contentId).then(response => {
                    this.contentData = response.data
                })
            },
            getInfo(){
                let contentId = this.$route.query.contentId
                if (contentId) {
                    getContentInfo(contentId).then(response => {
                        this.contentData = response.data
                    })
                } else {
                    this.$message.error('contentId为空');
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .header {
        display: flex;
        align-items: center;
        padding: 0;
    }
    .el-divider--horizontal {
        margin: 10px 0;
    }

    .bannerheight {
        height: 280px;
        background-color: #74BBF1;
        color: #fff;
        z-index: -1;
    }

    .bannerbg {
        position: relative;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .dmbanneroverlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(32, 32, 32, 0.49);
        z-index: -1;
    }

    .title-text {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .margin {
        width: 1200px;
        margin: 20px auto;
    }

    @media screen and (min-width: 1200px) {
        .col {
            margin-top: 0;
        }
    }

    @media screen and (max-width: 1200px) {
        .col {
            margin-top: 0;
        }
    }

    @media screen and (max-width: 870px) {
        .margin {
            width: 100%;
        }

        .col {
            margin-top: 0;
        }
    }

    @media screen and (max-width: 570px) {
        .margin {
            width: 100%;
        }

        .col {
            margin-top: 20px;
        }
    }
</style>
